import Link from 'next/link';
import { GroundFragment } from '@amf/shared/types/graphql';

interface Props {
  ground: GroundFragment;
  prefixes: { ground: string };
}

function GroundListItem({ ground, prefixes }: Props) {
  return (
    <Link href={`${prefixes.ground}/${ground.id}`}>
      <a className='GroundListItem'>
        <div className='GroundListItem__image'>
          <i className='icons-stadium'></i>
        </div>
        <div className='GroundListItem__content'>
          <h4 className='GroundListItem__title'>{ground.name}</h4>
          <p className='GroundListItem__subtitle'>{ground.address}</p>
        </div>
      </a>
    </Link>
  );
}

export default GroundListItem;
